<template>
  <v-layout
    row
    align-center
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <div class="title">
            <h3 :style="titleStyle" class="headline">{{ $t('welcome') }}</h3>
          </div>
          <div class="mt-5">
            <h4 :style="titleStyle">Loading menu....</h4>
            <v-progress-linear :indeterminate="true" />
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'welcome-view',
  layout: 'default',
  metaInfo () {
    return { title: this.$t('home') }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ])
  },
  titleStyle () {
    return {
      color: this.theme.orders_name_color
    }
  },
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-top: 65px;
}
</style>



// WEBPACK FOOTER //
// src/pages/welcome.vue